import { useMutation } from "react-query";
import { addAcquisition } from "../../../../../actions/Utilities/Acquisition";
import { toast } from "components/toastNotification";
import { IAcquisitionConfig } from "../Type";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateAcquisitionConfig,
  acquisitionConfigReFetching,
} from "../atoms/atoms";

const useAddAcquisition = () => {
  const setIsAddState = useSetRecoilState(addStateAcquisitionConfig);
  const [isReFetching, setIsReFetching] = useRecoilState(
    acquisitionConfigReFetching
  );

  const { mutate } = useMutation(
    (NewData: IAcquisitionConfig) => addAcquisition(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Acquisition Config failed", res.Message, "error");
        } else {
          let title = "Adding Acquisition Config Failed";
          let message = "";
          let type: "success" | "error" | "warning" = "error";

          if (res == "Success") {
            title = "Success";
            message = "Acquisition Config Added Successfully";
            type = "success";
          } else if (res == "Action object is null") {
            title = "Action object is Null";
            message = "Action Object is missing.";
            type = "error";
          } else if (res == "The data already exists!") {
            title = "Adding Acquisition Config Failed ";
            message = `Duplication Error: ${res}`;
            type = "error";
          } else if (res.includes("Notification insert Failed")) {
            title = "Success";
            message = `Acquisition Config Added Successfully, BUT ${res}`;
            type = "warning";
          } else if (
            ["Operation Failed!", "Acquisition Name not found"].includes(res)
          ) {
            message = `Error: ${res}`;
          }

          toast.fire(title, message, type);
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Acquisition Config failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddAcquisition;
